import { z } from 'zod';
import { AssetLifecycleDtoSchema } from '@terra/shared-dto-types';

export const SignalLinkedFindingPreviewSchema = z.object({
  id: z.string(),
  title: z.string(),
  shortDescription: z.string().nullable().optional(),
  status: z.string(),
  severity: z.string(),
  discoveryDate: z.coerce.date(),
  createdAt: z.coerce.date(),
  lifecycle: AssetLifecycleDtoSchema,
});

export type SignalLinkedFindingPreviewDto = z.infer<
  typeof SignalLinkedFindingPreviewSchema
>;
